import { jsx as _jsx } from "react/jsx-runtime";
import { formatNumber } from '../../../utility/formatNumber';
import { checkMultiplicity } from '../../extra/utilities/MultiplicityUtilities';
function SignalDeltaHzColumn({ row, onHover, format, info, rowSpanTags, }) {
    const signal = row.tableMetaInfo.signal;
    if (!signal)
        return _jsx("td", { children: '' });
    return (_jsx("td", { ...rowSpanTags, ...onHover, children: !checkMultiplicity(signal.multiplicity, ['m'])
            ? `${formatNumber(row.from * info.originFrequency, format)} - ${formatNumber(row.to * info.originFrequency, format)}`
            : info?.originFrequency
                ? formatNumber(signal.delta * info.originFrequency, format)
                : '' }));
}
export default SignalDeltaHzColumn;
